import classNames from "classnames";
import React from "react";
import { useTheme } from "@/components/ThemeProvider";

import "./PlainButton.less";

export interface PlainButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  type?: "link" | "button";
}

function PlainButton({ className, type, ...rest }: PlainButtonProps) {
  const { isDarkMode } = useTheme();

  return (
    <button
      className={classNames(
        "plain-button",
        "clickable",
        { "plain-button-link": type === "link" },
        { "dark-mode": isDarkMode },
        className
      )}
      type="button"
      {...rest}
    />
  );
}

export default PlainButton;
